var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuMobileBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 19,
    viewBox: "0 0 22 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.86662 18.5H20.5333C21.175 18.5 21.7 17.825 21.7 17C21.7 16.175 21.175 15.5 20.5333 15.5H1.86662C1.22495 15.5 0.699951 16.175 0.699951 17C0.699951 17.825 1.22495 18.5 1.86662 18.5ZM1.86662 11H20.5333C21.175 11 21.7 10.325 21.7 9.5C21.7 8.675 21.175 8 20.5333 8H1.86662C1.22495 8 0.699951 8.675 0.699951 9.5C0.699951 10.325 1.22495 11 1.86662 11ZM0.699951 2C0.699951 2.825 1.22495 3.5 1.86662 3.5H20.5333C21.175 3.5 21.7 2.825 21.7 2C21.7 1.175 21.175 0.5 20.5333 0.5H1.86662C1.22495 0.5 0.699951 1.175 0.699951 2Z",
    fill: "#292929",
    stroke: "white",
    strokeWidth: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuMobileBlack);
export default __webpack_public_path__ + "static/media/menu-mobile-black.f66ef4b0718ae82cf99cec8b1de02a53.svg";
export { ForwardRef as ReactComponent };